'use strict';

function UnkownStoreError(store) {
  this.name = 'Unknown store';
  this.message = 'Unknown store ' + store;
}

UnkownStoreError.prototype = Error.prototype;

module.exports = UnkownStoreError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/errors/unknownStoreError.js
 ** module id = 566
 ** module chunks = 0
 **/